/* One owner for pointer, keyboard and touch state; no competing Focal timers. */
if (!customElements.get('inusual-navigation')) {
  customElements.define('inusual-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.header = this.closest('store-header') || this;
      this.items = Array.from(this.querySelectorAll('.header__linklist-item'));
      const parts = (item) => ({ item, trigger: item.querySelector('.header__linklist-link'), panel: item.querySelector('.furniture-menu') });
      this.entries = this.items.map(parts);
      this.entries.forEach((entry) => {
        entry.trigger.addEventListener('pointerdown', (event) => {
          entry.touchWasOpen = event.pointerType === 'touch' && this.active === entry;
        }, options);
        entry.item.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          clearTimeout(this.closeTimer);
          this.open(entry);
        }, options);
        entry.trigger.addEventListener('click', (event) => {
          if (entry.panel && !matchMedia('(hover: hover)').matches && !entry.touchWasOpen) {
            event.preventDefault();
            this.open(entry);
          }
        }, options);
      });
      // The header includes both the gap below the label and the absolute panel.
      this.header.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.header.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'touch') this.closeTimer = setTimeout(() => this.close(), 220);
      }, options);
      this.addEventListener('focusin', (event) => {
        const entry = this.entries.find(({ item }) => item.contains(event.target));
        if (entry && !this.suppressFocus) this.open(entry);
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close();
      }, options);
      this.addEventListener('keydown', (event) => {
        const entry = this.entries.find(({ item }) => item.contains(event.target));
        if (!entry?.panel) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          this.suppressFocus = true;
          entry.trigger.focus();
          this.suppressFocus = false;
        } else if (event.key === 'ArrowDown' && event.target === entry.trigger) {
          event.preventDefault();
          this.open(entry);
          entry.panel.querySelector('a')?.focus();
        }
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.header.contains(event.target)) this.close();
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const entry = this.entries.find(({ item }) => item.contains(event.target));
        if (entry) this.open(entry);
      }, options);
      this.addEventListener('shopify:block:deselect', () => this.close(), options);
      window.addEventListener('resize', () => this.close(), options);
      window.addEventListener('blur', () => this.close(), options);
    }
    open(entry) {
      clearTimeout(this.closeTimer);
      if (this.active === entry) return;
      this.close();
      if (!entry.panel) return;
      this.active = entry;
      entry.panel.hidden = false;
      entry.trigger.setAttribute('aria-expanded', 'true');
      this.dispatchEvent(new CustomEvent('desktop-nav:dropdown:open', { bubbles: true }));
    }
    close() {
      clearTimeout(this.closeTimer);
      if (!this.active) return;
      this.active.panel.hidden = true;
      this.active.trigger.setAttribute('aria-expanded', 'false');
      this.active = null;
      this.dispatchEvent(new CustomEvent('desktop-nav:dropdown:close', { bubbles: true }));
    }
    disconnectedCallback() {
      this.close();
      this.controller.abort();
    }
  });
}
